import React, { useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { SvgIcon } from '@mui/material';
import { Container } from "react-bootstrap";
import { HeroImage } from './HeroImage/HeroImage';
import HelpMeDecide from './HelpMeDecide/HelpMeDecide';
import GettingCoveredSteps from './GettingCoveredSteps/GettingCoveredSteps';
import CostlyMistakes from './CostlyMistakes/CostlyMistakes';
import Carriers from './Carriers/Carriers';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';
import BeforeFooter from '../BeforeFooter/BeforeFooter';
import Marketing from "./Marketing/Marketing";
import PolicyReviewIcon from '../../icons/policyReview.svg?react';
import CalculatorIcon from '../../icons/calculator.svg?react';
import Testimonials from "../Common/Testimonials/Testimonials";
import './Home.scss';

const Home = (props) => {

  const [account] = useState(getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY))
  const [showNeedsAnalysis, setShowNeedsAnalysis] = useState(false);
  const [enablePolicyReview, setEnablePolicyReview] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0,0);
    if (!account || !account.account) {
      return;
    }

    if (account.account.redirectUrl) {
      navigate(account.account.redirectUrl);
    }

    setShowNeedsAnalysis(account.account.enableNeedsAnalysis != null ? account.account.enableNeedsAnalysis : true);
    setEnablePolicyReview(account.account.enablePolicyReview != null ? account.account.enablePolicyReview : false);
  }, [account])

  return (
    <Container fluid className="home">
      {account && account.account &&
        <Fragment>
          <Helmet>
            <title>{`Insurance from ${account.account.accountName}`}</title>
          </Helmet>

          <HeroImage cardContent={props.productInfo} />
          {account.account.isTestimonialPanelEnable &&
            <Fragment>
              <br />
              <Testimonials isShowCard={true} isShowPanel={true} />
            </Fragment>
          }
          {showNeedsAnalysis &&
            <HelpMeDecide
              title='How much life insurance do I need?'
              subTitle='Life Insurance Needs Analysis'
              icon={<SvgIcon component={CalculatorIcon} className="need-icons" color="primary" />}
            />
          }
          {enablePolicyReview &&
            <HelpMeDecide
              enablePolicyReview={enablePolicyReview}
              title='Do I have the right coverage?'
              subTitle='Life Insurance Policy Review'
              icon={<SvgIcon component={PolicyReviewIcon} className="need-icons" color="primary" />}
            />
          }
          <Marketing/>
          <GettingCoveredSteps />
          <CostlyMistakes />
          <Carriers />
          <BeforeFooter title="Let's get some life insurance." href="#product-tiles" />
        </Fragment>
      }

    </Container>
  );
}

export default Home;
